import actionTypes from "data/actions/actionTypes";
import immutable from "object-path-immutable";

// state.toggles {}
//     ._selected[] of string toggle.value
//     .counts {} of string toggle.value=toggle.count

export function getSelected(toggles) {
    let result = [];
    toggles
        .filter((toggle) => toggle.isSelected)
        .forEach((toggle) => result.push(toggle.value));
    return result;
}

const togglesReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.TOGGLES_PERSIST:
        case actionTypes.TOGGLES_CHANGE:
            return immutable.set(
                state,
                [action.payload.name, "_selected"],
                getSelected(action.payload.toggles)
            );

        case actionTypes.TOGGLES_UPDATECOUNTER:
            const keys = Object.keys(action.payload.counts);
            if (keys.length === 1) {
                // updating only one counter
                const state2 = immutable.set(
                    state,
                    [action.payload.name, "counts", keys[0]],
                    action.payload.counts[keys[0]]
                );
                if (action.payload.status !== undefined) {
                    const state3 = immutable.set(
                        state2,
                        [action.payload.name, "status", keys[0]],
                        action.payload.status[keys[0]]
                    );
                    return state3;
                }
                return state2;
            } else {
                //updating all
                const state2 = immutable.set(
                    state,
                    [action.payload.name, "counts"],
                    action.payload.counts
                );
                if (action.payload.status !== undefined) {
                    const state3 = immutable.set(
                        state2,
                        [action.payload.name, "status"],
                        action.payload.status
                    );
                    return state3;
                }
                return state2;
            }
        /* istanbul ignore next */
        case actionTypes.PERSIST_PURGE:
            return {};
        default:
            return state;
    }
};

export default togglesReducer;

export const selectedTogglesSelector = (state: Object, viewName: string) =>
    state.toggles &&
    state.toggles[viewName] &&
    state.toggles[viewName]["_selected"]
        ? state.toggles[viewName]["_selected"]
        : undefined; // used by TogglesHandler to load initialState
